import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dkyz23ez6j: FaireBrandEntity = {
  token: "b_dkyz23ez6j",
  type: "brand",
  name: "Molly Bz",
  avatarUrl:
    "https://cdn.faire.com/fastly/955a2229d04ee5653ecb2234cbdaf37de6bd093c9a2dfb5d02634c5307c9dbcb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a872c222815f45fee92c4776313738f2eb0ec713d4627a60cf71c50803a84bd9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/955a2229d04ee5653ecb2234cbdaf37de6bd093c9a2dfb5d02634c5307c9dbcb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a872c222815f45fee92c4776313738f2eb0ec713d4627a60cf71c50803a84bd9.jpeg",
  location: "Eagle river, AK, USA",
  minimumOrderDollars: 69,
  rating: 4.8,
  reviewCount: 37,
  isInsider: true,
  description:
    "Molly B was a single mom from a rural Alaskan town that found herself down to her last $150. She had to think fast to feed her son and pay her bills. So she started making gourmet cookies. In just 4 months she went from 20 dz a week to 45 dz a day and had been featured on Buzzfeed. The rest is history!\nJust 3 years later they have used her cookies in the Oscars gifting suite, International Emmy gala gift bags, Forbes, Food Network and more! Her cookies have a wonderful gourmet theme with fun packaging and even puts her story on the back of every package.\n\nEvery cookie is bougie, fun, huge and delicious. Indulgent foods are way up in the last 3 years and Molly Bz is here for it! Your customers will come back again and again for Molly Bz cookies",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:31.232Z",
    importedBy: "entity-db-cli",
  },
};
